import { AlertContainer, ButtonContainer, Container, Content, Header } from "./style";
import { Main, ErrorMessage, InputContainer } from "./style";
import InputText from "../../components/ui/inputText";
import { Button } from "../../components/Button";
import { useForm, Controller } from "react-hook-form";
import * as z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import InputMask from "react-input-mask";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../services/api";
import { toast } from "react-toastify";

export default function RequestCpfModal() {
	const { token } = useAuth();
	const [isOpen, setIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const schema = z.object({
		cpf: z
			.string({ required_error: "CPF é obrigatório" })
			.min(14, "CPF deve ter 14 dígitos")
			.max(14, "CPF deve ter 14 dígitos"),
	});

	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm({
		resolver: zodResolver(schema),
		defaultValues: {
			cpf: "",
		},
	});

	useEffect(() => {
		try {
			const fetchUserCpf = async () => {
				const response = await api.get("/v1/getUserCpf", {
					headers: { token },
				});
				if (!response.isValid) {
					setIsOpen(true);
				}
			};
			fetchUserCpf();
		} catch {}
	}, [token]);

	const onSubmit = async (data) => {
		try {
			setIsLoading(true);

			const response = await api.put(
				"/v1/updateUserCpf",
				{ cpf: data.cpf },
				{ headers: { token } },
			);

			toast.success(response.data.message);
			setIsOpen(false);
		} catch (error) {
			toast.error(
				error?.response?.data?.message ||
					"Erro ao atualizar o telefone, tente novamente.",
			);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			{isOpen && (
				<Container>
					<Content>
						<Header>
							<h3>Atualização de CPF</h3>
							<span>Atualize as informações do seu CPF</span>
						</Header>
						<Main>
							<form onSubmit={handleSubmit(onSubmit)}>
								<Controller
									control={control}
									name="cpf"
									render={({ field: { onChange, value } }) => (
										<InputContainer>
											<InputMask
												mask="999.999.999-99"
												value={value || ""}
												onChange={(event) => {
													onChange(event.target.value);
												}}
											>
												{(inputProps) => (
													<InputText
														{...inputProps}
														label="Digite seu CPF"
														placeholder="999.999.999-99"
														type="text"
														id="cpf"
														removeMargin
													/>
												)}
											</InputMask>
											{errors?.phone && (
												<ErrorMessage>{errors.phone.message}</ErrorMessage>
											)}
										</InputContainer>
									)}
								/>
								<AlertContainer>
									<span>Não iremos mais solicitar seu CPF depois desta atualização</span>
								</AlertContainer>
								<ButtonContainer>
									<Button type="submit" disabled={isLoading}>
										Confirmar
									</Button>
								</ButtonContainer>
							</form>
						</Main>
					</Content>
				</Container>
			)}
		</>
	);
}
